// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-16[data-v-527a7d45] {\n  margin-top: 16px;\n}\n.mb-16[data-v-527a7d45] {\n  margin-bottom: 16px;\n}\n[data-v-527a7d45] .el-dialog__header .el-dialog__title {\n  font-size: 16px;\n  color: #333;\n  font-weight: 600;\n}\n[data-v-527a7d45] .el-cascader__search-input {\n  min-width: 40px !important;\n}\n[data-v-527a7d45] .el-dialog__body {\n  max-height: 500px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
